import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  exabeamFields: [],
  exabeamAlerts: [],
  exabeamAlert: null,
  exabeamAlertLog: null,
  emailResponse: null,
  updateResponse: null,
  alertDescription: null,
  alertsFromInflux: [],
};

const exabeamSlice = createSlice({
  name: 'exabeam',
  initialState,
  reducers: {
    start: (state) => {
      state.loading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setExabeamFields: (state, action) => {
      state.loading = false;
      state.error = null;
      state.exabeamFields = action.payload;
    },
    setExabeamAlerts: (state, action) => {
      state.loading = false;
      state.error = null;
      state.exabeamAlerts = action.payload;
    },
    setExabeamAlert: (state, action) => {
      state.loading = false;
      state.error = null;
      state.exabeamAlert = action.payload;
    },
    setExabeamAlertLog: (state, action) => {
      state.loading = false;
      state.error = null;
      state.exabeamAlertLog = action.payload;
    },
    setEmailResponse: (state, action) => {
      state.loading = false;
      state.error = null;
      state.emailResponse = action.payload;
    },
    setUpdateResponse: (state, action) => {
      state.loading = false;
      state.error = null;
      state.updateResponse = action.payload;
    },
    setAlertDescription: (state, action) => {
      state.loading = false;
      state.error = null;
      state.alertDescription = action.payload;
    },
    setAlertsFromInflux: (state, action) => {
      state.alertsFromInflux = action.payload;
      state.loading = false;
    },
    setResetExabeam: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setExabeamFields,
  setExabeamAlerts,
  setExabeamAlert,
  setExabeamAlertLog,
  setEmailResponse,
  setUpdateResponse,
  setAlertDescription,
  setAlertsFromInflux,
  setResetExabeam
} = exabeamSlice.actions;

export default exabeamSlice.reducer;
